// Central apartment data — fetched from backend, fallback to local seed for SSR/first paint.
export const SEASONAL_PRICES = {
  1: 190, 2: 190, 3: 190, 4: 190, 5: 190, 6: 190,
  7: 219, 8: 219, 9: 239, 10: 190, 11: 229, 12: 229,
};

export function priceForDate(d) {
  return SEASONAL_PRICES[d.getMonth() + 1] || 190;
}

export function computeStayTotal(checkIn, checkOut) {
  if (!checkIn || !checkOut) return { nights: 0, subtotal: 0, discount: 0, discountPercent: 0, total: 0, averageNightly: 0 };
  const ms = 24 * 60 * 60 * 1000;
  const nights = Math.max(Math.round((checkOut - checkIn) / ms), 0);
  if (nights === 0) return { nights: 0, subtotal: 0, discount: 0, discountPercent: 0, total: 0, averageNightly: 0 };
  let subtotal = 0;
  const cur = new Date(checkIn);
  for (let i = 0; i < nights; i++) {
    subtotal += priceForDate(cur);
    cur.setDate(cur.getDate() + 1);
  }
  const discountPercent = nights >= 5 ? 10 : 0;
  const discount = Math.round((subtotal * discountPercent) / 100 * 100) / 100;
  const total = Math.round((subtotal - discount) * 100) / 100;
  return {
    nights,
    subtotal: Math.round(subtotal * 100) / 100,
    discount,
    discountPercent,
    total,
    averageNightly: Math.round((subtotal / nights) * 100) / 100,
  };
}

export const APARTMENT_SEED = {
  id: "attico-skyline-milano",
  slug: "attico-skyline-milano",
  title: "Attico Panoramico Milano | Skyline e metro a 4 min",
  short_title: "Attico Skyline Milano",
  location: "Caiazzo · Milano Centrale",
  address: "Via Giulio e Corrado Venini 14, Milano",
  short_description:
    "Un attico luminoso all'ultimo piano con terrazza privata e vista a 180° sullo skyline di Milano. A 4 minuti dalla metro Caiazzo, 8 dalla Stazione Centrale.",
  long_description:
    "Benvenuti in un attico raffinato e completamente ristrutturato, sospeso sui tetti di Milano. Dall'alto del suo ultimo piano, l'appartamento regala una vista panoramica a 180° sullo skyline cittadino — un colpo d'occhio che vi accompagnerà dal risveglio fino al tramonto.",
  price_per_night: 190,
  size_sqm: 45,
  max_guests: 4,
  bedrooms: 1,
  beds: 2,
  bathrooms: 1,
  rating: 5.0,
  reviews_count: 42,
  cover_image: "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/ywhdeula_vista%20skyline.png",
  gallery: [
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/ywhdeula_vista%20skyline.png",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/uyy0a8pa_10.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/6ptantq5_3.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/nw7nfxn5_foto%20casa.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/9193cl9j_4.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/6btdnt29_2.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/8qbx7fom_5.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/8jqs08gm_6.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/edegp8ms_7.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/kph72vzk_8.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/i561godi_9.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/6akn29ch_11.jpg.jpeg",
    "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/weayef8c_bagno%20def.jpg",
  ],
};

export const TESTIMONIALS = [
  {
    name: "Slavena R.",
    location: "Sofia, Bulgaria",
    avatar: "https://images.unsplash.com/photo-1660160628977-3ad376b8b73b",
    text: "Posizione perfetta per muoversi con qualsiasi mezzo. A piedi dalla Stazione Centrale e dalle metro M1 e M2. Negozi e ristoranti a due passi, l'appartamento è esattamente come nelle foto.",
    rating: 5,
  },
  {
    name: "Dennis K.",
    location: "Stati Uniti",
    avatar: "https://images.unsplash.com/photo-1567760855784-589f09ed5dc6",
    text: "Vista sulla città spettacolare. Appartamento perfetto per una coppia o un viaggiatore singolo. Tutto pulito, moderno, e il check-in autonomo ha funzionato senza problemi.",
    rating: 5,
  },
  {
    name: "Giulia M.",
    location: "Roma",
    avatar: "https://images.pexels.com/photos/5998055/pexels-photo-5998055.jpeg",
    text: "La terrazza con vista skyline è qualcosa di speciale. Ottima base per visitare Milano: metro a due minuti e Corso Buenos Aires a pochi passi. Tornerò sicuramente.",
    rating: 5,
  },
];
